import { render, staticRenderFns } from "./EditCorrespondent.vue?vue&type=template&id=3f1f7b6f&"
import script from "./EditCorrespondent.vue?vue&type=script&lang=js&"
export * from "./EditCorrespondent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports